module.exports = __webpack_public_path__ + "img/va-vr.48a2283d.png";